import { withUserGuard } from '@utils/guards/withUserGuard.component'

import { AddUserPage } from './add-user.page'

export * from './add-user.page'

export const GuardAddUserPage = withUserGuard(AddUserPage)
